import glamorous from 'glamorous';

export default glamorous.h1({
  position: 'absolute',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  height: 1,
  width: 1,
  margin: -1,
  padding: 0,
  border: 0,
});



// WEBPACK FOOTER //
// ./src/components/util/PageTitleHeading.js